import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getConfigObject, useBaseData } from "../utils/utils";
import { UserControllerApi } from "../services";

interface UseUsersListProps {
  userId?: string;
  xTENANTID?: string;
  disable?: boolean;
}

/**
 * @author rajkumar rathod
 */
export function useGetUserDetail({
  userId,
  xTENANTID,
  disable,
}: UseUsersListProps): useBaseData<any> {
  return useQuery({
    queryKey: ["user-staff-profile", userId, xTENANTID],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      if (disable) return;
      return new UserControllerApi(getConfigObject())
        .getUser(userId ?? "", xTENANTID)
        .then((res) => res?.data);
    },
  });
}
